<!-- ========== Left Sidebar Start ========== -->

<!-- <ng-template #contentTemplate>
  <div id="sidebar-menu">
    <ul class="metismenu list-unstyled" id="side-menu" #sideMenu>
      <ng-container *ngFor="let item of menuItems">
        <li>
          <a *ngIf="hasItems(item)" href="javascript:void(0);" class="is-parent"
            [ngClass]="{'has-arrow': !item.badge, 'has-dropdown': item.badge}">
            <i class="bx {{item.icon}}" *ngIf="item.icon"></i>
            <span> {{ item.label | translate }}</span>
            <span class="badge rounded-pill float-end bg-{{item.badge.variant}}" *ngIf="item.badge">{{item.badge.text |
              translate}}</span>
          </a>

          <a [routerLink]="item.link" *ngIf="!hasItems(item)" class="side-nav-link-ref" routerLinkActive="active">
            <i class="bx {{ item.icon }}" *ngIf="item.icon"></i>
            <span> {{ item.label | translate }}</span>
            <span class="badge rounded-pill bg-{{item.badge.variant}} float-end" *ngIf="item.badge">{{item.badge.text |
              translate}}</span>
          </a>

          <ul *ngIf="hasItems(item)" class="sub-menu" aria-expanded="false">
            <li *ngFor="let subitem of item.subItems">
              <a [routerLink]="subitem.link" *ngIf="!hasItems(subitem)" class="side-nav-link-ref"
                [attr.data-parent]="subitem.parentId" routerLinkActive="active">
                {{ subitem.label | translate}}
              </a>
              <a *ngIf="hasItems(subitem)" class="side-nav-link-a-ref has-arrow" href="javascript:void(0);"
                [attr.data-parent]="subitem.parentId">
                {{ subitem.label | translate}}
              </a>
              <ul *ngIf="hasItems(subitem)" class="sub-menu mm-collapse" aria-expanded="false">
                <li *ngFor="let subSubitem of subitem.subItems">
                  <a [attr.data-parent]="subSubitem.parentId" [routerLink]="subSubitem.link" routerLinkActive="active"
                    class="side-nav-link-ref">
                    {{ subSubitem.label | translate }}
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ng-container>
      <li style="bottom: 0">
        <a class="side-nav-link-ref" routerLinkActive="active" style="cursor: pointer;" (click)="logout()">
          <i class="bx bx-log-out-circle"></i>
          <span> Logout</span>
        </a>
      </li>
    </ul>
  </div>
</ng-template> -->
<!-- Sidebar -->

<!-- <div class="vertical-menu">
  <ngx-simplebar class="h-100" #componentRef>
    <div *ngIf="!isCondensed">
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </div>
    <div *ngIf="isCondensed">
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </div>
  </ngx-simplebar>
</div> -->
<!-- Left Sidebar End -->

<ng-template #contentTemplate>
  <!--- Sidemenu -->
  <div id="sidebar-menu">
    <ul class="metismenu list-unstyled" id="side-menu" #sideMenu>
      <ng-container *ngFor="let item of menuItems">
        <li
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: false }"
        >
          <!-- Parent with subitems -->
          <a
            *ngIf="hasItems(item)"
            href="javascript:void(0);"
            class="is-parent"
            [ngClass]="{ 'has-arrow': !item.badge, 'has-dropdown': item.badge }"
          >
            <i class="bx {{ item.icon }}" *ngIf="item.icon"></i>
            <span>{{ item.label | translate }}</span>
            <span
              class="badge rounded-pill float-end bg-{{ item.badge.variant }}"
              *ngIf="item.badge"
            >
              {{ item.badge.text | translate }}
            </span>
          </a>

          <!-- Normal link -->
          <a
            [routerLink]="item.link"
            *ngIf="!hasItems(item)"
            class="side-nav-link-ref"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: false }"
          >
            <i class="bx {{ item.icon }}" *ngIf="item.icon"></i>
            <span>{{ item.label | translate }}</span>
            <span
              class="badge rounded-pill bg-{{ item.badge.variant }} float-end"
              *ngIf="item.badge"
            >
              {{ item.badge.text | translate }}
            </span>
          </a>

          <!-- Submenu -->
          <ul *ngIf="hasItems(item)" class="sub-menu" aria-expanded="false">
            <li
              *ngFor="let subitem of item.subItems"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: false }"
            >
              <a
                [routerLink]="subitem.link"
                *ngIf="!hasItems(subitem)"
                class="side-nav-link-ref"
                [attr.data-parent]="subitem.parentId"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: false }"
              >
                {{ subitem.label | translate }}
              </a>

              <a
                *ngIf="hasItems(subitem)"
                class="side-nav-link-a-ref has-arrow"
                href="javascript:void(0);"
                [attr.data-parent]="subitem.parentId"
              >
                {{ subitem.label | translate }}
              </a>

              <!-- Sub-submenu -->
              <ul
                *ngIf="hasItems(subitem)"
                class="sub-menu mm-collapse"
                aria-expanded="false"
              >
                <li
                  *ngFor="let subSubitem of subitem.subItems"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: false }"
                >
                  <a
                    [attr.data-parent]="subSubitem.parentId"
                    [routerLink]="subSubitem.link"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: false }"
                    class="side-nav-link-ref"
                  >
                    {{ subSubitem.label | translate }}
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ng-container>
    </ul>

  </div>
  <!-- Logout pinned at bottom -->
  <div class="sidebar-logout">
    <button class="logout-btn" (click)="logout()">
      <i class="bx bx-log-out-circle"></i> Logout
    </button>
  </div>
</ng-template>

<!-- Sidebar -->
<div class="vertical-menu">
  <ngx-simplebar class="h-100" #componentRef>
    <div *ngIf="!isCondensed">
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </div>
    <div *ngIf="isCondensed">
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </div>
  </ngx-simplebar>
</div>
<!-- Left Sidebar End -->
